import {Component, OnInit} from '@angular/core';
import {GovBrService} from "../../services/govbr.service";
import {UsuarioLdap} from "../../models/usuario-ldap";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ValidatorService} from "../../core/services/validator.service";
import {Usuario} from "../../models/usuario";
import {UsuarioService} from "../../services/usuario.service";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-completar-cadastro-ad',
    templateUrl: './completar-cadastro-ad.component.html'
})
export class CompletarCadastroAdComponent implements OnInit {

    private usuarioldap: UsuarioLdap = new UsuarioLdap();
    public form: FormGroup;

    constructor(
        private govBrService: GovBrService,
        private validator: ValidatorService,
        private usuarioService: UsuarioService,
        private loadingService: NgxSpinnerService,
        private messageService: MessageService,
        private router: Router) { }

    ngOnInit(): void {
        let storedUser = this.govBrService.getLocalItem('ldapUser');
        this.govBrService.destroyLocalItem('ldapUser');

        this.form = new FormGroup({
            txt_nome: new FormControl(this.usuarioldap.txt_nome, [
                Validators.required,
            ]),
            num_cpf: new FormControl(this.usuarioldap.num_cpf, [
                Validators.required,
                ValidatorService.cpf
            ], [this.validator.existingCpfValidator()]),
            num_telefone: new FormControl(this.usuarioldap.num_telefone, [
                Validators.required,
                ValidatorService.telefone
            ]),
            txt_cargo: new FormControl(this.usuarioldap.txt_cargo, [
                Validators.required
            ]),
            txt_orgao: new FormControl(this.usuarioldap.txt_orgao, [
                Validators.required
            ]),
            txt_unidade: new FormControl(this.usuarioldap.txt_unidade, [
                Validators.required
            ]),
            txt_situacao: new FormControl(this.usuarioldap.txt_situacao, [
                Validators.required
            ]),
            txt_email: new FormControl( this.usuarioldap.txt_email, [
                Validators.required,
                Validators.email
            ], [this.validator.existingEmailValidator()])
        });

        this.form.patchValue({
            num_cpf: storedUser.num_cpf,
            txt_nome: storedUser.txt_nome,
            num_telefone: storedUser.num_telefone,
            txt_email: storedUser.txt_email,
            txt_unidade: storedUser.txt_unidade,
            txt_orgao: 'MDR',
            txt_situacao: 'ATIVO',
        });
    }

    store(): void {
        this.form.markAsTouched();
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (invalid.length === 0) {
            this.loadingService.show();
            let form = this.form.value as UsuarioLdap;
            this.usuarioService.completaCadastroAd(form).subscribe((data: any) => {
                this.loadingService.hide();
                this.messageService.showSuccess('Usuario cadastrado com sucesso !');
                this.router.navigateByUrl("/login");
            }, (error) => {
                this.loadingService.hide();
                this.messageService.showResponseError(error.error);
            });
        } else {
            this.messageService.showAlert("Preencha todos os campos corretamente");
        }
    }
}
